'use client';
import { useContext, useEffect } from 'react';
import { ResponseModuleStoreFront } from '@/src/interfaces/data-contracts';
import { DeviceContext } from '@/src/store/contexts/device-context';
import { InnerContainer } from '../../ui/common/inner-container';
import CSRLink from '../../ui/csrlink';
import ImageWithFallback from '../../ui/image/image-with-fallback';

function PopularProducts({
  popularProducts,
  pageName,
}: Readonly<{ popularProducts: ResponseModuleStoreFront | undefined; pageName: string }>) {
  const { isMobile } = useContext(DeviceContext);

  useEffect(() => {
    if (popularProducts?.contents?.length === 0) return;
    setTimeout(() => {
      const dataLayer = (window && 'dataLayer' in window && (window.dataLayer as any[])) || null;
      dataLayer?.push({
        event: 'ecInternalPromotionImpression',
        eventCategory: 'Promotion Impression',
        eventAction: pageName,
        eventLabel: 'Widget',
        ecommerce: {
          promoView: {
            promotions: popularProducts?.contents?.map((item) => ({
              id: item.id,
              name: item.title,
              creative: item.link,
              position: item.displayOrder,
            })),
          },
        },
      });
    }, 1000);
  }, []);

  if (!(popularProducts?.contents && popularProducts?.contents?.length > 0)) {
    return <></>;
  }

  return (
    <InnerContainer>
      <h2 className="mb-6 text-[20px] font-semibold leading-[28px]">{popularProducts.description}</h2>
      <div className="flex flex-col gap-3 md:flex-row md:gap-6">
        {popularProducts.contents.map((item, i) => (
          <button
            key={item.id}
            // onClick={() => {}}
            className="group rounded-[12px] border-[1px] border-[#E7E7E7] p-2 text-left hover:border-[#9493D7] active:bg-[#F0F0F9] md:w-1/3"
          >
            <CSRLink
              event={{
                event: 'ecInternalPromotionClick',
                eventCategory: 'Promotion Click',
                eventAction: pageName,
                eventLabel: 'Widget',
                ecommerce: {
                  promoClick: {
                    promotions: [
                      {
                        id: item.id,
                        name: item.title,
                        creative: item.link,
                        position: item.displayOrder,
                      },
                    ],
                  },
                },
              }}
              href={item.link ?? '#'}
              className="flex h-full flex-col"
            >
              <div className="relative mb-4 h-[186px] w-full overflow-hidden rounded-[12px]">
                <ImageWithFallback fill alt="" src={item.imagePath} />
              </div>
              <div className="mb-auto flex">
                <div className="mr-2 md:mr-4">
                  <p className="mb-2 text-[16px] font-semibold leading-[24px] text-[#252525]">{item.title}</p>
                  <span className="text-[14px] leading-[20px] text-[#252525]">{item.shortDescription}</span>
                </div>
                <div className="ml-auto flex h-[24px] w-[24px] items-center justify-center transition duration-75 group-hover:rotate-[-45deg] md:h-[32px] md:w-[32px]">
                  <svg
                    width={isMobile ? '12' : '16'}
                    height={isMobile ? '12' : '16'}
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 11L11 1M11 1H1M11 1V11"
                      stroke="#4A49BB"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </CSRLink>
          </button>
        ))}
      </div>
    </InnerContainer>
  );
}

export default PopularProducts;
